import type { GeneralSettingsData } from '../../../models';

export const isAppointmentRoomRequired = (settings?: Pick<GeneralSettingsData, 'allowAppointmentsWithoutRoom'>): boolean =>
    settings?.allowAppointmentsWithoutRoom !== true;
